module.exports = __webpack_public_path__ + "584780f0b465ac482b4dd526164577d9.jpg";